export default "__VITE_ASSET__BONy6zSc__"